import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllCitiesForSelectOptionsUseCaseInterface } from 'domain/usecases';

import { HttpStatusCode } from '../../protocols/http';

export class RemoteGetAllCitiesForSelectOptions
  implements GetAllCitiesForSelectOptionsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetAllCitiesForSelectOptionsUseCaseInterface.Params,
  ): Promise<GetAllCitiesForSelectOptionsUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: params?.search ? `${this.url}?search=${params.search}` : this.url,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
